import { createRouter, createWebHistory } from 'vue-router'

// 路由懒加载 - 只在访问时才加载对应组件
const HomePage = () => import('@/components/pages/HomePage.vue')
const QuestionPage = () => import('@/components/pages/QuestionPage.vue')
const QuizPage = () => import('@/components/pages/QuizPage.vue')
const SuccessPage = () => import('@/components/pages/SuccessPage.vue')
const TermsOfService = () => import('@/components/legal/TermsOfService.vue')
const PrivacyPolicy = () => import('@/components/legal/PrivacyPolicy.vue')
const ChildSafetyStandards = () => import('@/components/legal/ChildSafetyStandards.vue')
const DeleteAccountGuide = () => import('@/components/legal/DeleteAccountGuide.vue')
const SubscriptionAgreement = () => import('@/components/legal/SubscriptionAgreement.vue')

const routes = [
  // ===== 核心业务页面 =====
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/quiz/:userName/:questionSetId?',
    name: 'QuizByUser',
    component: QuizPage
  },
  {
    path: '/success',
    name: 'Success',
    component: SuccessPage
  },

  // ===== 法务/政策页面 =====
  {
    path: '/terms-of-service',
    name: 'Terms',
    component: TermsOfService
  },
  {
    path: '/privacy-policy',
    name: 'Privacy',
    component: PrivacyPolicy
  },
  {
    path: '/child-safety-standards',
    name: 'ChildSafety',
    component: ChildSafetyStandards
  },
  {
    path: '/delete-account-guide',
    name: 'DeleteAccount',
    component: DeleteAccountGuide
  },
  {
    path: '/subscription-agreement',
    name: 'Subscription',
    component: SubscriptionAgreement
  },
  {
    path: '/:userName/:action?',
    name: 'QuestionByUser',
    component: QuestionPage
  },

  // 404 兜底 - 未匹配的路径回到首页
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 进入成功页后把地址栏还原为来源页，避免暴露 /success
router.afterEach((to, from) => {
  if (to.name !== 'Success') return
  if (!from.name || from.name === 'Success') return
  if (typeof window === 'undefined') return

  const maskPath = from.fullPath
  if (!maskPath) return

  window.history.replaceState(window.history.state, '', maskPath)
})

export default router
